import React from 'react';
import MaterialTable, { MTableEditField } from 'material-table';
import { Paper } from '@material-ui/core';
import { Localization } from '../helpers/localization';
import { getCurrentUser } from '../helpers/authentication';
import moment from 'moment';
import { factureService } from '../services/factureService';
import { FileUploadCell } from './FileUploadCell';

const Factures = React.memo(
  (props) => {
    const {
      job,
      setMessage,
      setVariant,
      loading,
      setOpenSnackbar,
      getJob,
      to,
      uploadFile,
      deleteFile,
    } = props;

    const columns = [
      { title: 'Facture Nr', field: 'name' },
      {
        title: 'Date',
        field: 'date',
        type: 'date',
        render: (rowData) => (
          <div>{moment(rowData.date).format('DD.MM.YYYY')}</div>
        ),
        initialEditValue: moment(),
      },
      {
        title: `Montant [${Number(job.totalFactures).toFixed(2)}]`,
        field: 'value',
        type: 'currency',
        currencySetting: { currencyCode: 'EUR', locale: 'fr-FR' },
        headerStyle: { textAlign: 'right' },
        editComponent: (props) => <MTableEditField {...props} type='number' />,
      },
      {
        title: `Payé [${Number(job.totalPaid).toFixed(2)}]`,
        field: 'paid',
        type: 'boolean',
      },
      {
        title: `Rg [${Number(job.totalRg).toFixed(2)}]`,
        field: 'rg',
        type: 'currency',
        currencySetting: { currencyCode: 'EUR', locale: 'fr-FR' },
        headerStyle: { textAlign: 'right' },
        editComponent: (props) => <MTableEditField {...props} type='number' />,
      },
      {
        title: 'Date a payé',
        field: 'datePaid',
        type: 'date',
        render: (rowData) => (
          <div>
            {moment(rowData.datePaid).isValid()
              ? moment(rowData.datePaid).format('DD.MM.YYYY')
              : ''}
          </div>
        ),
        initialEditValue: moment(),
      },
      {
        title: 'Document',
        field: 'filePath',
        editable: 'never',
        sorting: false,
        render: (rowData) =>
          rowData &&
          FileUploadCell(
            rowData,
            rowData.filePath,
            getCurrentUser().token,
            to,
            handleFileSubmit,
            handleFileDelete
          ),
      },
    ];

    const handleFileSubmit = (factureId) => (event) => {
      event.preventDefault();
      var formData = new FormData();
      formData.append('file', event.target.files[0]);
      uploadFile(factureId, formData);
    };

    const handleFileDelete = (id) => (event) => {
      deleteFile(id);
    };

    const options = {
      draggable: false,
      actionsColumnIndex: -1,
      pageSizeOptions: [],
      paging: true,
      pageSize: 5,
      search: false,
      addRowPosition: 'first',
    };

    const editable = {
      onRowAdd: (newData) =>
        new Promise((resolve, reject) => {
          const datePaid = moment(newData.datePaid).isValid()
            ? moment(newData.datePaid).format('YYYY-MM-DD')
            : null;
          const item = {
            jobId: job.id,
            name: newData.name,
            date: moment(newData.date).format('YYYY-MM-DD'),
            value: parseFloat(newData.value),
            paid: newData.paid,
            rg: parseFloat(newData.rg),
            datePaid: datePaid,
          };
          factureService
            .create(item)
            .then(() => {
              getJob(job.id);
              resolve();
            })
            .catch(() => {
              setVariant('error');
              setMessage('Entrée invalide');
              setOpenSnackbar(true);
              reject();
            });
        }),
      onRowUpdate: (newData, oldData) =>
        new Promise((resolve, reject) => {
          const datePaid = moment(newData.datePaid).isValid()
            ? moment(newData.datePaid).format('YYYY-MM-DD')
            : null;
          const item = {
            id: newData.id,
            jobId: job.id,
            name: newData.name,
            date: moment(newData.date).format('YYYY-MM-DD'),
            value: parseFloat(newData.value),
            paid: newData.paid,
            rg: parseFloat(newData.rg),
            datePaid: datePaid,
          };
          factureService
            .update(item)
            .then(() => {
              getJob(job.id);
              resolve();
            })
            .catch(() => {
              setVariant('error');
              setMessage('Entrée invalide');
              setOpenSnackbar(true);
              reject();
            });
        }),
      onRowDelete: (oldData) =>
        new Promise((resolve, reject) => {
          factureService
            .deleteFacture(oldData.id)
            .then(() => {
              getJob(job.id);
              resolve();
            })
            .catch(() => {
              setVariant('error');
              setMessage('Erreur');
              setOpenSnackbar(true);
              reject();
            });
        }),
    };

    return (
      <div>
        <MaterialTable
          components={{
            Container: (props) => <Paper {...props} elevation={0} />,
          }}
          data={job.factures}
          columns={columns}
          options={options}
          title={'Facturation - Fakturacija'}
          editable={editable}
          isLoading={loading}
          localization={Localization}
        />
      </div>
    );
  },
  (prevProps, nextProps) =>
    JSON.stringify(prevProps.job.factures) ===
      JSON.stringify(nextProps.job.factures) &&
    prevProps.loading === nextProps.loading
);

export default Factures;
